// kufer-kurs-loader.js

import {
  loadUserFavorites,
  toggleFavoriteRequest,
} from "../kufer-utils/kufer-favorites.js";
import { populateCourseCard } from "../kufer-utils/kufer-course-card.js";

export function initializeKuferCourseLoader() {
  const containers = document.querySelectorAll(".kufer-kurs-liste-container");
  if (containers.length === 0) return;

  /**
   * Hilfsfunktion zum Laden der Favoriten-IDs vor dem Rendern der Blöcke
   */
  function loadUserFavoritesAndInit() {
    // Nutzt jetzt die zentrale Funktion
    loadUserFavorites();
    initAllBlocks();
  }

  /**
   * Die Haupt-Initialisierung aller gefundenen Blöcke
   */
  function initAllBlocks() {
    containers.forEach((container) => {
      const blockId = container.id.replace("kufer-kurse-", "");
      const filterDataElement = document.getElementById(container.id + "-data");
      if (!filterDataElement) {
        console.warn(
          `Kufer Kurs Loader: Konnte Konfigurationselement für #${container.id} nicht finden.`,
        );
        return;
      }

      let filterData;
      try {
        filterData = JSON.parse(filterDataElement.textContent);
      } catch (e) {
        console.error(
          "Kufer Kurs Loader: Fehler beim Parsen der Filterdaten.",
          e,
        );
        return;
      }

      const fachbereicheDataContainer =
        document.getElementById("fachbereiche-data") || null;
      const fachbereicheData = fachbereicheDataContainer
        ? JSON.parse(fachbereicheDataContainer.textContent)
        : {};

      const currentUrl = window.location.href;
      const expiryDate = new Date();
      expiryDate.setTime(expiryDate.getTime() + 1 * 60 * 60 * 1000);

      document.cookie =
        "last_course_list=" +
        encodeURIComponent(currentUrl) +
        "; expires=" +
        expiryDate.toUTCString() +
        "; path=/";

      const clientLimit = parseInt(filterData.limit, 10) || 5;
      delete filterData.limit;

      const apiBatchSize = 120;
      let apiPage = 1;
      let clientPage = 1;
      let fetchedCoursesStore = [];

      const loaderMessage = container.querySelector(".kufer-loader-message");
      const targetContainer = container.querySelector("[data-template-target]");
      const template = container.querySelector("[data-course-template]");

      const pagingControls = container.querySelector(".kufer-paging-controls");
      const prevButton = container.querySelector(".kufer-page-prev");
      const nextButton = container.querySelector(".kufer-page-next");

      if (
        !targetContainer ||
        !template ||
        !pagingControls ||
        !prevButton ||
        !nextButton
      ) {
        console.error(
          `Kufer Kurs Loader (${blockId}): Initialisierung fehlgeschlagen.`,
        );
        if (loaderMessage) loaderMessage.style.display = "none";
        targetContainer.innerHTML =
          '<p class="error-message">Fehler bei der Block-Initialisierung.</p>';
        return;
      }

      function fetchBatchAndRender(pageToFetch, renderLastPage = false) {
        if (loaderMessage) loaderMessage.style.display = "block";
        pagingControls.style.display = "none";
        targetContainer.innerHTML = "";

        const endpointPath = filterData.endpoint_path || "/kurse";
        const token = filterData.token;
        const apiKey = filterData.api_key;

        const params = new URLSearchParams();
        for (const key in filterData) {
          const value = filterData[key];
          if (
            key !== "api_key" &&
            key !== "endpoint_path" &&
            key !== "token" &&
            key !== "limit" &&
            value !== "" &&
            value !== null &&
            value !== 0
          ) {
            params.append(key, value);
          }
        }

        params.append("page", pageToFetch);
        params.append("limit", apiBatchSize);
        params.append("endpoint", endpointPath);
        if (token) params.append("token", token);

        const cleanEndpoint = endpointPath.startsWith("/")
          ? endpointPath.substring(1)
          : endpointPath;
        params.append("endpoint", cleanEndpoint);

        const restUrl = `${window.location.origin}/kufer-api.php?${params.toString()}`;

        fetch(restUrl)
          .then((response) => {
            if (!response.ok)
              throw new Error(`Netzwerkfehler: ${response.status}`);
            return response.json();
          })
          .then((data) => {
            if (loaderMessage) loaderMessage.style.display = "none";
            fetchedCoursesStore = data;

            if (renderLastPage) {
              clientPage =
                Math.ceil(fetchedCoursesStore.length / clientLimit) || 1;
            } else {
              clientPage = 1;
            }
            apiPage = pageToFetch;
            renderClientPage(clientPage);
          })
          .catch((error) => {
            if (loaderMessage) loaderMessage.style.display = "none";
            targetContainer.innerHTML =
              '<p class="error-message">Daten konnten nicht geladen werden.</p>';
            console.error(
              `Fehler beim Abrufen der Kufer-Kurse (${blockId}):`,
              error,
            );
          });
      }

      function renderClientPage(page) {
        targetContainer.innerHTML = "";

        const start = (page - 1) * clientLimit;
        const end = start + clientLimit;
        const coursesToRender = fetchedCoursesStore.slice(start, end);

        if (fetchedCoursesStore.length === 0 && apiPage === 1) {
          targetContainer.innerHTML =
            '<p class="no-results">Für Ihre Kriterien wurden keine Kurse gefunden.</p>';
          pagingControls.style.display = "none";
          return;
        }

        renderCoursesHtml(coursesToRender);

        const totalClientPagesInBatch = Math.ceil(
          fetchedCoursesStore.length / clientLimit,
        );
        const hasApiMorePages = fetchedCoursesStore.length === apiBatchSize;
        const isFirstOverall = apiPage === 1 && page === 1;
        const isLastOverall =
          !hasApiMorePages && page === totalClientPagesInBatch;

        prevButton.classList.toggle("disabled", isFirstOverall);
        nextButton.classList.toggle("disabled", isLastOverall);

        if (!isFirstOverall || !isLastOverall) {
          pagingControls.style.display = "grid";
        } else {
          pagingControls.style.display = "none";
        }
      }

      function renderCoursesHtml(courses) {
        const fragment = document.createDocumentFragment();
        const agId = filterData.firma_id !== "" ? filterData.firma_id : "";
        const token = filterData.token || "";

        courses.forEach((kurs) => {
          const { courseEntry, favBtn } = populateCourseCard(template, kurs, {
            fachbereicheData,
            agId,
            token,
          });

          if (favBtn) {
            favBtn.addEventListener("click", function (e) {
              e.preventDefault();
              e.stopPropagation();

              // Ruft die ausgelagerte API-Logik auf und übergibt das Merklisten-Spezialverhalten als Callback
              toggleFavoriteRequest(kurs.knr, favBtn, (currentStatus) => {
                if (currentStatus === "removed") {
                  if (
                    document.body.classList.contains(
                      "page-template-merkliste",
                    ) ||
                    container.id === "kufer-kurse-user-merkliste"
                  ) {
                    courseEntry.style.opacity = "0";
                    setTimeout(() => {
                      courseEntry.remove();
                      if (targetContainer.children.length === 0) {
                        targetContainer.innerHTML =
                          '<p class="no-results">Du hast noch keine Kurse auf deiner Merkliste.</p>';
                      }
                    }, 300);
                  }
                }
              });
            });
          }

          fragment.appendChild(courseEntry);
        });

        targetContainer.appendChild(fragment);
      }

      // Event Listener
      nextButton.addEventListener("click", function (event) {
        event.preventDefault();
        if (nextButton.classList.contains("disabled")) return;
        const totalClientPagesInBatch = Math.ceil(
          fetchedCoursesStore.length / clientLimit,
        );
        if (clientPage < totalClientPagesInBatch) {
          clientPage++;
          renderClientPage(clientPage);
        } else if (fetchedCoursesStore.length === apiBatchSize) {
          fetchBatchAndRender(apiPage + 1);
        }
      });

      prevButton.addEventListener("click", function (event) {
        event.preventDefault();
        if (prevButton.classList.contains("disabled")) return;
        if (clientPage > 1) {
          clientPage--;
          renderClientPage(clientPage);
        } else if (apiPage > 1) {
          fetchBatchAndRender(apiPage - 1, true);
        }
      });

      fetchBatchAndRender(1, false);
    });
  }

  loadUserFavoritesAndInit();
}
